import { useLanguage } from "../hooks";
import { sify } from 'chinese-conv';

const Translate = (toTranslate) => {
    const [userLanguage] = useLanguage();
    let text;
    switch (userLanguage) {
        case "traditional":
            text = toTranslate;
            break;
        case "simplified":
            text = sify(toTranslate);
            break;
        default:
            text = toTranslate;
            break;
    }

    return text;
}

export default Translate;